import {Grid as MuiGrid, GridProps as MuiGridProps, useTheme} from "@mui/material";
import {createStyles, makeStyles} from "@mui/styles";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => createStyles({
    dialogContainer: {
        display: "flex",
        paddingTop: "1em",
        paddingBottom: "1em",
    },
}));

export interface GridProps extends MuiGridProps {
    noStyle?: boolean
}

export default function Grid(props: GridProps) {
    const classes = useStyles(useTheme());
    const {noStyle, ...otherProps} = props;

    let appliedStyle = undefined;
    if (!props.noStyle) {
        if (props.container) {
            appliedStyle = classes.dialogContainer;
        }
    }

    let defaultRowSpacing: number | undefined = undefined;
    let defaultColumnSpacing: number | undefined = undefined;
    if (props.container && props.spacing === undefined) {
        defaultRowSpacing = 2;
        defaultColumnSpacing = 1;
    }

    return (
        <MuiGrid className={appliedStyle}
                rowSpacing={defaultRowSpacing}
                columnSpacing={defaultColumnSpacing}
                {...otherProps} >
            {props.children}
        </MuiGrid>
    );
}
